// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { SaveProjectCaeDTO } from '@project/model/vo/save-project-cae.dto';

@JsonObject('SaveProjectCaeResponseDTO')
export class SaveProjectCaeResponseDTO {

  @JsonProperty('groupId', 'Number')
  public groupId: number = undefined;

  @JsonProperty('savedProjects', '[SaveProjectCaeDTO]')
  public savedProjects: SaveProjectCaeDTO[] = undefined;
}
